<template>
    <div>
        <v-card
            outlined
            class="pa-4 ma-0"
        >
            <alert-component 
                v-if="planTotalCustomers && total >= planTotalCustomers" :alert="alerts.limit"
            />

            <!-- Form 1 -->
            <template v-else>
               <div>
                    <alert-component :alert="alerts.inicial" />
                    <v-form ref="form">
                        <v-row dense>
                            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <v-select
                                    v-model="item.finalidade"
                                    :items="items.finalidade"
                                    :rules="[rules.required]"
                                    outlined
                                    dense
                                    :class="$css_field"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">Finalidade</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
                                <v-select
                                    v-model="item.como_conheceu"
                                    :items="howToKnowItems"
                                    :rules="[rules.required]"
                                    outlined
                                    dense
                                    :class="$css_field"
                                    item-text="description"
                                    item-value="description"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">Como conheceu?</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                                <v-select
                                    v-model="type_contact"
                                    :items="items.contacts"
                                    :rules="[rules.required]"
                                    outlined
                                    dense
                                    :class="$css_field"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">Tipo</span>
                                    </template>
                                </v-select>
                            </v-col>
                            <v-col v-if="type_contact == 'E-mail'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                                <v-text-field
                                    v-model="item.email"
                                    outlined
                                    dense
                                    :class="$css_field"
                                    :rules="[rules.required]"
                                    :key="'email-field'"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">E-mail</span>
                                    </template>
                                </v-text-field>
                            </v-col>  
                            <v-col v-if="type_contact == 'Telefone'" cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                                <v-text-field
                                    v-model="item.telefone"
                                    v-mask="['(##) ####-####', '(##) #####-####']"
                                    outlined
                                    dense
                                    :class="$css_field"
                                    :rules="[rules.required]"
                                    :key="'phone-field'"
                                >
                                    <template v-slot:label>
                                        <span :class="$css_field">Telefone</span>
                                    </template>
                                </v-text-field>  
                            </v-col>
                            <v-col cols="12" xs="12" sm="12" md="2" lg="2" xl="2">
                                <v-btn
                                    color="primary"
                                    @click="validateCheckNew"
                                    :class="$css_button"
                                    :block="$vuetify.breakpoint.smAndDown"
                                >
                                    <span>Pesquisar</span>
                                </v-btn>
                            </v-col>   
                        </v-row>

                        <!-- caso nao encontreo telefone ou email informado -->    
                        <template  v-if="check_new.status && check_new.clients.data.length == 0">
                            <v-row dense class="mt-4">
                                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <v-text-field
                                        v-model="item.nome"
                                        :rules="[rules.required]"
                                        outlined
                                        dense
                                        required
                                        :class="$css_field"
                                    >
                                        <template v-slot:label>
                                            <span :class="$css_field">Nome</span>
                                        </template>
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12" xs="12" sm="12" md="4" lg="4" xl="4">
                                    <v-select
                                        v-model="item.user_id"
                                        :items="users.data"
                                        :rules="[rules.required]"
                                        item-text="name"
                                        item-value="id"
                                        outlined
                                        dense
                                        :class="$css_field"
                                    >
                                        <template v-slot:label>
                                            <span :class="$css_field">Colaborador de atendimento</span>
                                        </template>
                                    </v-select>
                                </v-col>
                                <v-col cols="12" xs="2" sm="2" md="4" lg="4" xl="4">
                                    <v-tooltip top max-width="650px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="item.property_codigos"
                                                outlined
                                                dense
                                                label="Codigos"
                                                append-icon="mdi-help-circle-outline"
                                                v-on="on"
                                                :class="$css_field"
                                                clearable
                                            >
                                                <template v-slot:label>
                                                    <span :class="$css_field">Código de Imoveis (Opcional)</span>
                                                </template>
                                            </v-text-field>
                                        </template>
                                        <span>
                                            Para cadastrar mais de um codigo basta separar por virgula
                                        </span>
                                    </v-tooltip>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col class="text-right" cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                                    <v-btn
                                        color="primary"
                                        @click="validate"
                                        :class="$css_button"
                                        :block="$vuetify.breakpoint.smAndDown"
                                    >
                                        <span>Cadastrar FAC</span>
                                    </v-btn>
                                </v-col>
                            </v-row>  
                        </template>
                        <!-- fim caso nao encontreo telefone ou email informado -->

                    </v-form>
               </div>
            </template>
            <!-- End Form 1 -->
            

            <!-- Caso na pesquisa encontre o cliente apos a pesquisa (11) 98271-3078 -->
            <template v-if="check_new.status">

                <template v-if="check_new.clients.data && check_new.clients.data.length > 0">
                    <div>
                        <alert-component :alert="alerts.check_new"></alert-component>

                        <v-card
                            class="mx-auto"
                            outlined
                        >
                            <v-data-table
                                :headers="headers.clients"
                                :items="check_new.clients.data"
                                :items-per-page="10"
                                sort-by="id"
                                class="elevation-1 table-striped"
                                :footer-props="{
                                'items-per-page-text':'Itens por página',   
                                'items-per-page-options': [5, 10],
                                'items-per-page-all-text': '',
                                'page-text': '{0}-{1} de {2}'
                            }"
                            >
                                <template v-slot:[`item.nome`]="{ item }">
                                    <span :class="$css_report_list">{{ item.nome }}</span>
                                </template>

                                <template v-slot:[`item.telefone`]="{ item }">
                                    <span :class="$css_report_list" v-if="item.telefone">{{ item.telefone | VMask(maskPhone(item.telefone)) }}</span>
                                    <span :class="$css_report_list" v-if="item.telefone2">{{ item.telefone2 | VMask(maskPhone(item.telefone2)) }}</span>
                                </template>

                                <template v-slot:[`item.email`]="{ item }">
                                    <span :class="$css_report_list">{{ item.email }}</span>
                                </template>

                                <template v-slot:[`item.details`]="{ item }">
                                    <span :class="$css_report_list">
                                        <span :class="$css_report_list">Data Cadastro: {{ item.created_at }}</span> <br />
                                        <span :class="$css_report_list">Data Atualizaçāo: {{ item.updated_at }}</span> <br />
                                        <span :class="$css_report_list">Número de FACS: {{ item.facs.length }}</span> 
                                    </span>
                                </template>
                                

                                <template v-slot:[`item.actions`]="{ item }">
                                    <v-card-actions>
                                        <v-tooltip top v-if="(me.profile == 'Master' || me.profile == 'Gerente') && item.facs && item.facs.length > 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon class="ml-8" @click="showFacs(item.facs)">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-face-agent</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>FACS cadastradas - visualizar</span>
                                        </v-tooltip>

                                        <v-tooltip top v-if="item.property_owners && item.property_owners.length > 0">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon class="ml-8" @click="showPropertyOwners(item.property_owners)">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-home</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Proprietario de imóveis - visualizar</span>
                                        </v-tooltip>

                                        <v-tooltip left>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-btn icon @click.prevent="setFac(item)" class="ml-8">
                                                    <v-icon v-bind="attrs" v-on="on">mdi-folder-plus</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Gerar FAC </span>
                                        </v-tooltip>
                                    </v-card-actions>     
                                </template>
                            </v-data-table>
                        </v-card>  
                    </div>
                </template>
                <!-- Caso existe o cliente ja cadastrado -->

                

            </template>
            <!-- fim --> 

        </v-card>
    </div>
</template>

<script>
import { FINALIDADE_ITEMS, CLASSIFICACAO_ITEMS } from './configs_fac/configs_fac.js'
import AlertComponent from '@/components/alert/AlertComponent.vue'

export default {
    name: "FacStore",

    components: {
        AlertComponent
    },

    created() {
        this.countFac()
        this.loadUsers()
    },

    mounted() {
        window.scrollTo(0, 0);
    }, 

    computed: {
        me () {
          return this.$store.state.auth.me
        },

        planTotalCustomers() {
            return this.me.tenant?.app_plan?.customers || '1';
        },

        howToKnowItems() {
            return (this.me.branch?.howtoknowitems && this.me.branch?.howtoknowitems.length > 0) ? this.me.branch?.howtoknowitems : [{ "description": "Site"}];
        },

        users() {
            return this.$store.state.users.items    
        },
    },    

    data () {
        return {    
            alerts: {
                inicial: {
                    show: 'null',
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['Informe os dados abaixo. O sistema verificará automaticamente se já existe o cliente cadastrado com o mesmo telefone ou e-mail.']
                },

                check_new: {
                    show: '',
                    type: 'warning',
                    icon: 'mdi-alert-outline',
                    messages: ['O sistema encontrou o cliente abaixo. Voce poderá confirmar a criaçāo da FAC ou informar outro telefone ou email.']
                },

                limit: {
                    show: '',
                    type: 'error',
                    icon: 'mdi-alert-outline',
                    messages: ['O limite de cadastro foi atingido. Entre em contato com AYT para migrar de plano ou exclua alguns registros desnecessários.']
                },
            },

            item: {},

            params: {
                users: {
                    paginate: 'false'
                }
            },

            type_contact: 'Telefone',

            check_new: {
                status: false,
                clients: {
                    data: []
                }
            },

            total: 0,

            items: {
               contacts: ['Telefone','E-mail'],
               finalidade: FINALIDADE_ITEMS,
               classificacao: CLASSIFICACAO_ITEMS,
               property_owners: [],
               facs: [],
            },
            
            rules: {
                required: value => !!value || 'Obrigatório',
                min:  v => (v && v.length >= 8) || 'Mininmo de 8 caracteres',
                email: value => /.+@.+/.test(value) || 'E-mail precisa ser válido'
            },

            show: {
                property_owners: false,
                facs: false,
            },

            property_show: {},
            fac_show: {},

            headers: {
                clients: [
                    { text: 'NOME', align: 'start', value: 'nome', },
                    { text: 'TELEFONE', value: 'telefone' },
                    { text: 'EMAIL', value: 'email' },
                    { text: 'DETALHES', value: 'details' },
                    { text: 'AÇÕES', value: 'actions', sortable: false },
                ],
                property_owners: [
                    { text: 'CODIGO', align: 'start', value: 'codigo', },
                    { text: 'STATUS', value: 'status' },
                    { text: 'TIPO IMOVEL', value: 'tipo_imovel' },
                    { text: 'ENDEREÇO', value: 'endereco' },
                    { text: 'AÇÕES', value: 'actions', sortable: false },
                ],
                facs: [
                    { text: 'CODIGO', align: 'start', value: 'codigo', },
                    { text: 'STATUS', value: 'status' },
                    { text: 'FINALIDADE', value: 'finalidade' },
                    { text: 'COLABORADORES', value: 'colaboradores' },
                    { text: 'AÇÕES', value: 'actions', sortable: false },
                ]
            },
        }
    },    

    methods: {
        countFac(){
            this.$store.dispatch('facs_total')
                        .then(response => {
                            this.total = response;
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        },

        loadUsers(){
            this.$store.dispatch('loadUsers', this.params.users)
        },

        validateCheckNew () {
            if (this.$refs.form.validate()) {
                this.checkNew(this.item)
            }
        },

        checkNew(item){
            item.checkNew = 'true'
            this.$store.dispatch('checkNewFac', item)
                        .then(response => {
                            this.check_new.status = true
                            this.check_new.clients = response 
                        })
                        .catch(error => {
                            
                        })
        },

        setFac(client){
            this.item.client_id = client.id
            this.item.nome = client.nome
            this.storeUpdate(this.item)
        },

        backNew(){
            this.check_new.status = false
            this.check_new.facs = {} 
        },
        
        validate () {
            if (this.$refs.form.validate()) {
                this.storeUpdate(this.item)
            }
        },

        storeUpdate(item){
            const action = 'storeFac'
            this.$store.dispatch(action, item)
                        .then(response => {
                            this.item = response.data   
                            this.$snotify.success('Cadastro com sucesso!')
                            this.editItem(this.item.id);
                        })
                        .catch(error => {
                            console.log(error)
                            this.$snotify.error('Erro no cadastro')
                        })
        
        },
        
        editItem(id){
            this.$router.push({
                name: 'admin.facs2.edit',
                params: { uuid: id }
            });
        },
    }    
}
</script>
